import React, { useState, useEffect } from 'react';

import styled from 'styled-components';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ActivityViewActionIcon from './ActivityViewActionIcon';

const StyledActivityEditActionWrapper = styled.div`
  position: absolute;
  right: -30px;
  top: 0;
`;

const ActivityViewDeepEditableField = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  activity,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  fieldsInEditMode,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  name,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onEditField,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onCancel,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onSave,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setParentState,
}) => {
  const getInitialValue = () => {
    const blocksFromHTML = htmlToDraft(activity[name] || '');
    const state = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    return EditorState.createWithContent(state);
  };

  const [value, setValue] = useState<any>(getInitialValue());

  useEffect(() => {
    const formatted = value
      ? draftToHtml(convertToRaw(value.getCurrentContent()))
      : '';
    if (setParentState) setParentState(formatted);
  }, [value]);

  const onCancelClick = () => {
    const initialValue = getInitialValue();
    setValue(initialValue);
    onCancel(name);
  };

  const onSaveClick = () => {
    const valueToSend = draftToHtml(convertToRaw(value.getCurrentContent()));
    onSave(name, valueToSend);
  };

  const getFileBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result);
    reader.onerror = error => {
      console.error(error);
      alert('Error while parsing an image');
    };
  };

  const imageUploadCallback = file =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    new Promise((resolve, reject) =>
      getFileBase64(file, data => resolve({ data: { link: data } }))
    );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  if (fieldsInEditMode.includes(name))
    return (
      <div>
        {onSave && (
          <ActivityViewActionIcon action='save' onClick={() => onSaveClick()} />
        )}
        {onCancel && (
          <ActivityViewActionIcon
            action='ban'
            onClick={() => onCancelClick()}
          />
        )}
        <Editor
          editorState={value}
          wrapperClassName='activity-deep-wrapper'
          editorClassName='activity-deep-editor'
          onEditorStateChange={newValue => setValue(newValue)}
          toolbar={{
            options: [
              'inline',
              'blockType',
              'fontSize',
              'fontFamily',
              'list',
              'textAlign',
              'colorPicker',
              'link',
              'embedded',
              'emoji',
              'remove',
              'history',
            ],
            image: {
              uploadCallback: imageUploadCallback,
              previewImage: true,
            },
          }}
        />
      </div>
    );
  return (
    <>
      <div
        className='activity-description'
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        dangerouslySetInnerHTML={{ __html: activity.description }}
      />
      <StyledActivityEditActionWrapper>
        <ActivityViewActionIcon
          action='edit'
          onClick={() => onEditField(name)}
        />
      </StyledActivityEditActionWrapper>
    </>
  );
};

export default React.memo(ActivityViewDeepEditableField);
